import { FormattedMessage } from 'react-intl';

import type { ApiNgWordWarningJSON } from 'mastodon/api/ng_words';
import { Button } from 'mastodon/components/button';
import {
  ModalShell,
  ModalShellActions,
  ModalShellBody,
} from 'mastodon/components/modal_shell';

/**
 * Shown instead of posting when the text contains NG words of someone it
 * mentions. Closing it goes back to the post, which is sent as is when
 * the button is pressed again.
 */
export const NgWordsWarningModal: React.FC<{
  warnings: ApiNgWordWarningJSON[];
  onClose: () => void;
}> = ({ warnings, onClose }) => (
  <ModalShell as='div'>
    <ModalShellBody>
      <h1>
        <FormattedMessage
          id='ng_words_warning.title'
          defaultMessage='This post contains words someone does not want to receive'
        />
      </h1>

      <ul>
        {warnings.map(({ account, words }) => (
          <li key={account.id}>
            <FormattedMessage
              id='ng_words_warning.item'
              defaultMessage='@{acct} does not want to receive: {words}'
              values={{
                acct: account.acct,
                words: <strong>{words.join(', ')}</strong>,
              }}
            />
          </li>
        ))}
      </ul>

      <p>
        <FormattedMessage
          id='ng_words_warning.hint'
          defaultMessage='Close this to edit the post, or press the post button again to send it as it is.'
        />
      </p>
    </ModalShellBody>

    <ModalShellActions>
      {/* eslint-disable-next-line jsx-a11y/no-autofocus -- we are in a modal */}
      <Button onClick={onClose} autoFocus>
        <FormattedMessage id='ng_words_warning.close' defaultMessage='Close' />
      </Button>
    </ModalShellActions>
  </ModalShell>
);
